export const SIZE_UNITS = {
    B: { unit: 'B', size: 1 },
    KiB: { unit: 'KiB', size: 1024 },
    MiB: { unit: 'MiB', size: 1048576 },
    GiB: { unit: 'GiB', size: 1073741824 },
    TiB: { unit: 'TiB', size: 1099511627776 },
    PiB: { unit: 'PiB', size: 1125899906842624 },
    EiB: { unit: 'EiB', size: 1152921504606846976 },
    ZiB: { unit: 'ZiB', size: 1180591620717411303424 },
    YiB: { unit: 'YiB', size: 1208925819614629174706176 }
}

const SIZE_UNITS_ARR = [SIZE_UNITS.B, SIZE_UNITS.KiB, SIZE_UNITS.MiB, SIZE_UNITS.GiB, SIZE_UNITS.TiB,
SIZE_UNITS.PiB, SIZE_UNITS.EiB, SIZE_UNITS.ZiB, SIZE_UNITS.YiB];

function getSizeWithUnit(byteValue, unit, showDecimal = false, showUnit = true) {
    const valueInUnit = byteValue / unit.size;
    const unitString = showUnit ? ` ${unit.unit}` : '';
    if (showDecimal || valueInUnit < 0.5) {
        const value = Number(valueInUnit.toFixed(2)).toLocaleString();
        return `${value}${unitString}`;
    }
    else {
        const value = Math.round(valueInUnit).toLocaleString();
        return `${value}${unitString}`;
    }
}

/**
 * Returns the formatted size as string with minimum unit.
 * If the value is less than the minimum unit, it will return the value with the minimum unit.
 * If the value is greater than or equal to the minimum unit, it will return the value
 * with minimum or a larger unit 
 */
export function formatSize(valueInBytes, minOutputUnit = SIZE_UNITS.GiB, showDecimal = false, showUnit = true) {
    if (typeof valueInBytes !== 'number' || isNaN(valueInBytes) || valueInBytes < 0) {
        return '';
    }
    if (valueInBytes < minOutputUnit.size) {
        return getSizeWithUnit(valueInBytes, minOutputUnit, showDecimal, showUnit);
    }
    else {
        for (let i = SIZE_UNITS_ARR.length - 1; i >= 0; i--) {
            const unit = SIZE_UNITS_ARR[i];
            if (valueInBytes >= unit.size) {
                return getSizeWithUnit(valueInBytes, unit, showDecimal, showUnit);
            }
        }
    }
}

// Returns the highest unit that can represent the value in bytes
// For example, if the value is 1024 bytes, it will return KiB
// If the value is 1048576 bytes, it will return MiB
export function getHighestUnit(valueInBytes) {
    for (let i = SIZE_UNITS_ARR.length - 1; i >= 0; i--) {
        const unit = SIZE_UNITS_ARR[i];
        if (valueInBytes >= unit.size) {
            return unit;
        }
    }
    return SIZE_UNITS.B;
}

/** * Converts a value in a specific unit to bytes.
 * @param {number} valueInUnit - The value in the specified unit.
 * @param {string} unit - The unit of the value (e.g., 'GiB', 'MiB').
 * @returns {number} - The value in bytes.
 */
export function getSizeInBytes(valueInUnit, unit) {
    if (typeof valueInUnit !== 'number' || isNaN(valueInUnit) || valueInUnit < 0) {
        return 0;
    }
    if (!unit || !SIZE_UNITS[unit.unit]) return 0;
    return valueInUnit * SIZE_UNITS[unit.unit].size;
}
